import rollbarConfig from "../configs/rollbarConfig"
import Rollbar from "rollbar"

const rollbarLogger = (user) => {
  const rollbar = new Rollbar(rollbarConfig(user))

  return {
    logInfo: (message, data) => rollbar.info(`${message} Please refresh and try again.`, data),
    logError: (message, error) => rollbar.error(`${message} Please refresh and try again.`, error),
  }
}

export default rollbarLogger